import React from 'react'
import styled from 'styled-components';

export default function Coefficient({ coef, isLose }: any) {
    return (
        <CoefficientWrapper isLose={isLose}>{coef}x</CoefficientWrapper>
    )
}

export const CoefficientWrapper = styled.div<{ isLose: boolean }>`
 color : ${({ isLose }) => isLose ? '#CB1212' : '#FFB000'};
 position: absolute;
 top: -75px;
 font-size: 28px;
 width: 100%;
 text-align: center;
`
